module.exports = __webpack_public_path__ + "media/images/city/090-arc-de-triomphe-b24daa1bc8bd15182919d7812e789c74.svg";